import '../styles/application.css'

// Load Stimulus controllers - all from app/javascript/controllers/ (the up-to-date versions)
import { Application } from "@hotwired/stimulus"
import PersonEditController from "../../javascript/controllers/person_edit_controller"
import SummaryTabsController from "../../javascript/controllers/summary_tabs_controller"
import ActionItemsController from "../../javascript/controllers/action_items_controller"
import DisclosureController from "../../javascript/controllers/disclosure_controller"
import DropdownController from "../../javascript/controllers/dropdown_controller"
import ModalController from "../../javascript/controllers/modal_controller"
import AutocompleteController from "../../javascript/controllers/autocomplete_controller"
import DonutChartController from "../../javascript/controllers/donut_chart_controller"
import PersonTodosController from "../../javascript/controllers/person_todos_controller"
import AddPersonController from "../../javascript/controllers/add_person_controller"
import MeetingNoteController from "../../javascript/controllers/meeting_note_controller"
import ProjectTeamController from "../../javascript/controllers/project_team_controller"
import ProjectMeetingsController from "../../javascript/controllers/project_meetings_controller"
import ProjectTodosController from "../../javascript/controllers/project_todos_controller"
import PaginatedListController from "../../javascript/controllers/paginated_list_controller"
import MeetingProjectController from "../../javascript/controllers/meeting_project_controller"
import FileUploadController from "../../javascript/controllers/file_upload_controller"
import DescriptionGeneratorController from "../../javascript/controllers/description_generator_controller"
import HeaderImageController from "../../javascript/controllers/header_image_controller"
import ProjectChatController from "../../javascript/controllers/project_chat_controller"
import PlatformActivityFilterController from "../../javascript/controllers/platform_activity_filter_controller"
import StoryCardController from "../../javascript/controllers/story_card_controller"
import StoryViewController from "../../javascript/controllers/story_view_controller"
import StorySearchController from "../../javascript/controllers/story_search_controller"
import StoryFavoriteController from "../../javascript/controllers/story_favorite_controller"
import PersonAutocompleteController from "../../javascript/controllers/person_autocomplete_controller"
import ObservationsLoadMoreController from "../../javascript/controllers/observations_load_more_controller"

const application = Application.start()
application.debug = import.meta.env.DEV
window.Stimulus = application

// Register controllers
application.register("person-edit", PersonEditController)
application.register("summary-tabs", SummaryTabsController)
application.register("action-items", ActionItemsController)
application.register("disclosure", DisclosureController)
application.register("dropdown", DropdownController)
application.register("modal", ModalController)
application.register("autocomplete", AutocompleteController)
application.register("donut-chart", DonutChartController)
application.register("person-todos", PersonTodosController)
application.register("add-person", AddPersonController)
application.register("meeting-note", MeetingNoteController)
application.register("project-team", ProjectTeamController)
application.register("project-meetings", ProjectMeetingsController)
application.register("project-todos", ProjectTodosController)
application.register("paginated-list", PaginatedListController)
application.register("meeting-project", MeetingProjectController)
application.register("file-upload", FileUploadController)
application.register("description-generator", DescriptionGeneratorController)
application.register("header-image", HeaderImageController)
application.register("project-chat", ProjectChatController)
application.register("platform-activity-filter", PlatformActivityFilterController)
application.register("story-card", StoryCardController)
application.register("story-view", StoryViewController)
application.register("story-search", StorySearchController)
application.register("story-favorite", StoryFavoriteController)
application.register("person-autocomplete", PersonAutocompleteController)
application.register("observations-load-more", ObservationsLoadMoreController)

// Import and register connections load more controller
import ConnectionsLoadMoreController from "../../javascript/controllers/connections_load_more_controller"
application.register("connections-load-more", ConnectionsLoadMoreController)

// Import and register company edit controller
import CompanyEditController from "../../javascript/controllers/company_edit_controller"
application.register("company-edit", CompanyEditController)

console.log('Stimulus controllers loaded')

// Dynamically load React only if root element exists
const rootEl = document.getElementById('root')
if (rootEl) {
  import('react').then((React) => {
    import('react-dom/client').then((ReactDOM) => {
      import('../App').then((module) => {
        const App = module.default
        const root = ReactDOM.createRoot(rootEl)
        root.render(
          React.createElement(React.StrictMode, null, 
            React.createElement(App)
          )
        )
      }).catch((e) => console.error('Failed to load App:', e))
    }).catch((e) => console.error('Failed to load ReactDOM:', e))
  }).catch((e) => console.error('Failed to load React:', e))
}

